import { IsNotEmpty, IsString } from 'class-validator';

export class AuthToken {
  @IsString()
  @IsNotEmpty()
  userId: string;

  @IsString()
  @IsNotEmpty()
  username: string;
}
